import produce from 'immer'
import { IBoard } from 'shared/models/Board'
import {
  BOARD_FETCH_FAILED,
  BOARD_FETCH_REQUESTED,
  BOARD_FETCH_SUCCESS,
  BOARD_MEMBERS_FETCH_FAILED,
  BOARD_MEMBERS_FETCH_REQUESTED,
  BOARD_MEMBERS_FETCH_SUCCESS,
  BOARD_PROCESSING_RESET,
  BOARD_UPDATE_RESPONSIBILITY_FAILED,
  BOARD_UPDATE_RESPONSIBILITY_REQUESTED,
  BOARD_UPDATE_RESPONSIBILITY_SUCCESS,
} from './actionTypes'
import { BoardActionTypes } from './types'

const initialState = {
  data: null as IBoard | null,
  loading: false,
  error: null,
  processing: false,
  processingError: null,
}

const reducer = (state = initialState, action: BoardActionTypes) => {
  switch (action.type) {
    case BOARD_FETCH_REQUESTED:
      return { ...state, loading: true }
    case BOARD_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null }
    case BOARD_FETCH_FAILED:
      return { ...state, loading: false, error: action.payload }
    case BOARD_MEMBERS_FETCH_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case BOARD_MEMBERS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...((state.data as unknown) as IBoard),
          members: action.payload,
        },
      }
    case BOARD_MEMBERS_FETCH_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case BOARD_UPDATE_RESPONSIBILITY_REQUESTED:
      return produce(state, (draft) => {
        draft.processing = true
      })
    case BOARD_UPDATE_RESPONSIBILITY_SUCCESS:
      return produce(state, (draft) => {
        let updatedBoard = { ...draft.data } as IBoard

        const member = updatedBoard?.members?.find(
          (x) => x.assignmentId === action.payload.assignmentId
        )
        if (member) member.responsibility = action.payload.value

        draft.data = updatedBoard
        draft.processing = false
        draft.processingError = null
      })

    case BOARD_UPDATE_RESPONSIBILITY_FAILED:
      return produce(state, (draft) => {
        draft.processing = false
        draft.processingError = action.payload
      })

    case BOARD_PROCESSING_RESET:
      return produce(state, (draft) => {
        draft.processing = false
        draft.processingError = null
      })
    default:
      return state
  }
}

export default reducer
